
import $ from 'jquery';
import _forEach from 'lodash/forEach';
import _isNaN from 'lodash/isNaN';
import GameController from '../game/GameController';
import { SELECTORS } from '../constants/selectors';
import TestController from './TestController';

/**
 * @property UI_TESTING_DIALOG_TEMPLATE
 * @type {string}
 * @final
 */
const UI_TESTING_DIALOG_TEMPLATE = `
    <div class="option-dialog dialog">
        <p class="dialog-title">Testing</p>
        <div class="dialog-body nice-scrollbar"></div>
    </div>`;

/**
 * @property UI_TESTING_DIALOG_INSTRUCIOTNS
 * @type {string}
 * @final
 */
const UI_TESTING_DIALOG_INSTRUCIOTNS = `
    <p class="dialog-text">
        This is used to test personnel on different attack scenarios. A test consists of steps where the aircraft are affected by attacks. 
        Then, the user can make guesses and add notes on the aircraft if they believe an aircraft is affected by an attack. 
        The commands that can be used are:
    </p>
            <ul style="padding-left: 40px; list-style-type: disc;">
                <li>
                    <b>guess - g - isAttack</b> <br>
                    Example: 'SBI654 g 1' (for attack type 1). To remove: 'SBI654 g 0'
                </li>
                <li>
                    <b>addText - at - updateText - ut</b> <br>
                    Example: 'SBI654 at prob fake'. To remove note: 'SBI654 at'
                </li>
                <li>
                    <b>starttest <testname> <username></b><br>
                    Example: 'starttest test1 user' (for test1).
                </li>
                <li>
                    <b>stoptest</b><br>
                    Example: 'stoptest'
                </li>
            </ul>
    <p class="dialog-text">
        After the test is completed, the user can download the test log. The test log can be used to evaluate the user's performance. The test log can be downloaded after the test is completed. The test log can also be download from the "Test log dwn" menu.
    </p>
    <p class="dialog-text">
        Information about testing and the attacks can be found <a href=\"/tutorial\" target=\"_blank\">here</a>.
            <style>
                .dialog-text a:visited {
                    color: #FF4191; /* Change this to your desired color */
                }
            </style>
    </p>
`;

/**
 * @property UI_TESTING_UPLOAD_INFO
 * @type {string}
 * @final
 */
const UI_TESTING_UPLOAD_INFO = `
    <p class="dialog-text">
        <h1 style="padding: 10px 16px; font-size: larger;">The test that are available are:</h1>
        <table style="margin-top: 10px; margin-left: 18px; margin-bottom: 10px; width: 90%;" id="${SELECTORS.IDS.TEST_LIST_OF_AVALIBLE_TESTS}">
        </table>
    </p>
`;

export default class TestUIController{
    
    constructor($element){

        /**
         * Root DOM element
         *
         * @property $element
         * @type {jquery|HTML Element}
         * @default $element
         */
        this.$element = $element;

        /**
         * Dialog DOM element
         *
         * @property $dialog
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialog = null;

        /**
         * Dialog's body DOM element
         *
         * @property $dialogBody
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialogBody = null;

        /**
         * Available tests
         * 
         * @property availableTests
         * @type {array}
         * @default []
         */
        this.availableTests = [];

        this.init();
    }

    /**
     * Initializes the testing dialog
     * 
     * @for TestUIController
     * @method init
     * @private
     */
    init(){
        this._buildDialog();

        this._getAndShowAvailableTests();
    }

    /**
     * Builds the testing dialog
     * 
     * @for TestUIController
     * @method _buildDialog
     * @private
     */
    _buildDialog() {
        this.$dialog = $(UI_TESTING_DIALOG_TEMPLATE);
        this.$dialogBody = this.$dialog.find(SELECTORS.DOM_SELECTORS.DIALOG_BODY);

        const $instructions = $(UI_TESTING_DIALOG_INSTRUCIOTNS);
        this.$dialogBody.append($instructions);

        const $uploadInfo = $(UI_TESTING_UPLOAD_INFO);
        this.$dialogBody.append($uploadInfo);

        this.$element.append(this.$dialog);

    }

    /**
     * Returns whether the testing dialog is open
     *
     * @for TestUIController
     * @method isDialogOpen
     * @return {boolean}
     */
    isDialogOpen() {
        return this.$dialog.hasClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * Toggles the testing dialog
     * 
     * @for TestUIController
     * @method toggleDialog
     */
    toggleDialog() {
        this.$dialog.toggleClass(SELECTORS.CLASSNAMES.OPEN);
    }

    _getAndShowAvailableTests() {
        this.availableTests = TestController.getAvailableTests();

        const $table = this.$dialog.find(`${SELECTORS.DOM_SELECTORS.TEST_LIST_OF_AVALIBLE_TESTS}`);

        $table.empty();

        if (this.availableTests.length === 0) {
            const $li = $(`<tr>No tests available</tr>`);
            $ul.append($li);
            return;
        }

        $table.append('<tr style="text-align:left; font-weight: bolder; font-size: small;"><th>Test Name</th><th>Attack intensity</th><th>Traffic intensity</th><th>Duration</th></tr>');

        _forEach(this.availableTests, (test) => {
            const $row = $(`<tr><td>${test.name}</td><td>${test.level}</td><td>${test.traffic}</td><td>${(test.duration / 60).toFixed(1)} min</td></tr>`);
            $table.append($row);
        });

    }

}